import { useRef, useEffect, useState } from 'react';
import { Scrollbar, Mousewheel, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import { useTranslation } from 'next-i18next';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/ShowroomsAccordionList/ShowroomsAccordionList.styles';
import { IPointOfPresence } from '@features/checkout/typescript';
import Heading from '@components/Heading/Heading';
import { getShowroomName } from '@utils/showroom';
import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
type PropsType = {
  active: boolean;
  isDesktop: boolean;
  showrooms: Array<IPointOfPresence>;
  setShowroomUuid: (newShowroomUuid: string) => void;
};
const ShowroomsAccordionList = ({
  active,
  isDesktop,
  showrooms,
  setShowroomUuid
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const swiperInstance = useRef<SwiperClass>(null);
  const [sortedShowrooms, setSortedShowrooms] = useState<Record<string, Array<IPointOfPresence>>>({});
  const [openCountryCode, setOpenCountryCode] = useState<string | null>(null);
  const sortShowroomsByCountry = () => {
    if (Array.isArray(showrooms) && showrooms.length && Object.keys(sortedShowrooms).length === 0) {
      const newSortedShowrooms: Record<string, Array<IPointOfPresence>> = {};
      showrooms.forEach(showroom => {
        if (showroom?.country?.code) {
          if (!newSortedShowrooms[showroom.country.code.toUpperCase()]) newSortedShowrooms[showroom.country.code] = [];
          newSortedShowrooms[showroom.country.code.toUpperCase()].push(showroom);
        }
      });
      setSortedShowrooms(newSortedShowrooms);
      if (!openCountryCode && Object.keys(newSortedShowrooms).length) setOpenCountryCode(Object.keys(newSortedShowrooms)[0]);
    }
  };
  const open = (key: string) => {
    setOpenCountryCode(key !== openCountryCode ? key : null);
  };
  useEffect(() => {
    sortShowroomsByCountry();
  }, [showrooms]);
  const renderItemList = (item: IPointOfPresence): JSX.Element => <div sx={styles.itemList}>
      <span>{item?.address?.city}</span>
      <Heading h={1} size={18} uppercase pb={8} mobile>
        {getShowroomName(item, t)}
      </Heading>
      <span>
        {item?.address?.street}, {item?.address?.postalCode}
      </span>
    </div>;
  return <div sx={styles.container(active, false)}>
      {isDesktop && <>
          <Swiper direction="vertical" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
        draggable: true,
        hide: false,
        dragSize: 80
      }} onSwiper={swiper => {
        swiperInstance.current = swiper;
      }} followFinger slidesPerView="auto" freeMode mousewheel>
            {Object.keys(sortedShowrooms).length > 0 && Object.keys(sortedShowrooms).map(countryCode => <div sx={styles.accordionItem} key={`${countryCode}-${Math.random()}`}>
                  <SwiperSlide key={`swiper-slide-${countryCode}-${Math.random()}`}>
                    <div sx={styles.accordionHeader(countryCode === openCountryCode)} onClick={() => open(countryCode)} aria-hidden="true">
                      <span>{t(`countryName.${countryCode.toUpperCase()}`)}</span>
                      <Button variant="iconOnly" addSx={styles.addButton} cy="CloseButton">
                        <Icon icon={countryCode === openCountryCode ? 'Minus2' : 'Add'} size="18px" />
                      </Button>
                    </div>
                  </SwiperSlide>
                  {countryCode === openCountryCode && sortedShowrooms[countryCode].map(showroom => showroom && showroom?.uuid && <SwiperSlide key={`${countryCode}-${showroom.uuid}-${Math.random()}`} onClick={() => showroom?.uuid ? setShowroomUuid(showroom.uuid) : null}>
                            {renderItemList(showroom)}
                          </SwiperSlide>)}
                </div>)}
          </Swiper>
        </>}
    </div>;
};
export default ShowroomsAccordionList;